import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import caseService from '../../services/caseService';
import { logout } from './authSlice';

export const fetchMyCase = createAsyncThunk(
  'case/fetchMy',
  async (_, { rejectWithValue }) => {
    try {
      const res = await caseService.getMyCase();
      return res.data?.case ?? null;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Could not load the case');
    }
  }
);

export const createCase = createAsyncThunk(
  'case/create',
  async (visa_type_id, { rejectWithValue }) => {
    try {
      const res = await caseService.createCase(visa_type_id);
      return res.data?.case ?? null;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Nu s-a putut crea dosarul');
    }
  }
);

export const fetchCaseById = createAsyncThunk(
  'case/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const res = await caseService.getCaseById(id);
      return res.data?.case ?? null;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Case not found');
    }
  }
);

const caseSlice = createSlice({
  name: 'case',
  initialState: {
    case: null,
    loading: false,
    error: null,
  },
  reducers: {
    setCase: (state, action) => {
      state.case = action.payload;
    },
    clearCase: (state) => {
      state.case = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyCase.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyCase.fulfilled, (state, action) => {
        state.loading = false;
        state.case = action.payload;
        state.error = null;
      })
      .addCase(fetchMyCase.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createCase.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCase.fulfilled, (state, action) => {
        state.loading = false;
        state.case = action.payload;
        state.error = null;
      })
      .addCase(createCase.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCaseById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCaseById.fulfilled, (state, action) => {
        state.loading = false;
        state.case = action.payload;
        state.error = null;
      })
      .addCase(fetchCaseById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(logout.fulfilled, (state) => {
        state.case = null;
        state.error = null;
      })
      // Sync case from auth responses (addMatcher must be last)
      .addMatcher(
        (action) =>
          ['auth/login/fulfilled', 'auth/googleLogin/fulfilled', 'auth/verifyEmail/fulfilled', 'auth/verifyAuth/fulfilled', 'auth/fetchProfile/fulfilled'].includes(action.type),
        (state, action) => {
          const payload = action.payload;
          const visaCase = payload?.case ?? (typeof payload === 'object' && !payload?.user ? null : undefined);
          if (visaCase !== undefined) state.case = visaCase;
        }
      );
  },
});

export const { setCase, clearCase } = caseSlice.actions;
export default caseSlice.reducer;
